<template>
     <a-form-item label="门店类型/级别" name='' v-if='open'>
      <a-select v-model:value="formLink.type_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
        </a-select-option>
      </a-select>
      <a-select class="m-l-20" v-model:value="formLink.level_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
      </a-select>
    </a-form-item>
</template>

<script>
export default {
  name:'store_type_level'
}
</script>